import React from "react"
import styles from "./Dimmer.module.scss"

const Dimmer = props => {
    return (
        <div className={props.active ? styles.dimmer : styles['dimmer-hidden']}>
            <i className="fa fa-spinner" aria-hidden="true"></i>
        </div>
    )
}

export default Dimmer
